import Loading from '@/components/Loading/Loading';
import { usePaymentSession } from '@/hooks/payment/usePaymentSession';
import { failedPaymentStatuses, successfulPaymentStatuses } from '@/utils/constants';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PayCallback = () => {
  const navigate = useNavigate();
  const { paymentSession, setPaymentSessionId, queryError } = usePaymentSession();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paymentSessionId = searchParams.get('PaymentSessionId');
    if (paymentSessionId) {
      setPaymentSessionId(paymentSessionId);
    }
  }, [setPaymentSessionId, searchParams]);

  useEffect(() => {
    if (paymentSession) {
      if (successfulPaymentStatuses.includes(paymentSession.payment.status?.toLowerCase())) {
        navigate(`/pay/confirmation/${paymentSession.paymentSessionId}`, { replace: true });
      } else if (failedPaymentStatuses.includes(paymentSession.payment.status?.toLowerCase())) {
        navigate(`/pay/${paymentSession.referenceCode}`, { replace: true });
      }
    }
  }, [paymentSession]);

  useEffect(() => {
    if (queryError) {
      navigate('/pay/error', { replace: true });
    }
  }, [queryError]);

  return <Loading height='50vh' />;
};

export default PayCallback;
